"use client";

import { useState, useCallback } from "react";

const defaultFilters = {
  gender: "Both",
  age: 29,
  distanceMin: 1,
  distanceMax: 50
};

export const useChatFilters = () => {
  const [filters, setFilters] = useState(defaultFilters);
  const [isLoading, setIsLoading] = useState(false);

  const updateFilters = useCallback(newFilters => {
    setFilters(newFilters);
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  // Convert UI filters to API format
  const getApiFilters = useCallback(
    () => {
      const apiFilters = {};

      if (filters.gender !== "Both") {
        apiFilters.gender =
          filters.gender.toLowerCase() === "boy" ? "male" : "female";
      }

      // For age, we can send a range around the selected age
      apiFilters.ageBand = filters.age;

      apiFilters.min_distance = filters.distanceMin;
      apiFilters.max_distance = filters.distanceMax;

      return apiFilters;
    },
    [filters]
  );

  // Function to apply filters (can be used for API calls)
  const applyFilters = useCallback(
    async apiCall => {
      setIsLoading(true);
      try {
        if (apiCall) {
          const apiFilters = getApiFilters();
          await apiCall(apiFilters);
        }
      } catch (error) {
        console.error("Error applying filters:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [getApiFilters]
  );

  return {
    filters,
    updateFilters,
    resetFilters,
    getApiFilters,
    applyFilters,
    isLoading
  };
};
